<template>
  <div>
    <FilmTabs/>
  </div>
</template>

<script>
const FilmTabs = () => import('@/components/FilmTabs.vue');

export default {
  name: 'FilmDetail',
  components: {
    FilmTabs,
  },
};
</script>
